import React from 'react'
import { renderRichText } from '@components/RichText'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import ArticleHeader from './subcomponents/articleHeader'
import WidthContainer from '@components/WidthContainer/WidthContainer'
import ArticleCarousel from '@components/ArticleCarousel'

const ArticleContent = ({
  category,
  title,
  author,
  publishedDate,
  featuredHero,
  content,
  relatedArticles,
  createdAt,
}) => {
  const image = featuredHero?.file?.url
  return (
    <div>
      <WidthContainer>
        <ArticleHeader
          category={category}
          title={title}
          author={author}
          publishedDate={publishedDate || createdAt}
          featuredHero={featuredHero}
        />
      </WidthContainer>
      {image && (
        <img
          loading="eager"
          src={image}
          alt="Featured Hero"
          className="object-cover w-full"
        />
      )}
      <div className="px-6 md:px-28 mx-auto max-w-[1308px]">
        <div className="p-6">
          {renderRichText({ richText: content, isArticle: true })}
        </div>
      </div>
      <ArticleCarousel header={'Related Articles'} articles={relatedArticles} />
    </div>
  )
}

export default ArticleContent
